import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';

import type { EdgeContentResponse } from './entities';
import { EdgeEnvironment } from './environment';

export class EdgeRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(EdgeEnvironment).url, session);
  }

  public getEdgeContent = (): SafePromise<EdgeContentResponse> => {
    const url = this.URL('api/edge');
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
